/**
 * The address a consent decision may send the browser to, or null.
 *
 * The server only ever answers with a redirect URI the client registered, and
 * registration accepts nothing but https and loopback http (`oauth/client.rs`).
 * The scheme half of that is repeated here because the value is assigned to
 * `window.location`, where a `javascript:` URL would run on the dashboard's own
 * origin with the user's session. If the server is right this costs nothing.
 */
export function consentRedirect(value: string): string | null {
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return null;
  }
  return url.protocol === 'https:' || url.protocol === 'http:' ? value : null;
}
